'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { usePlpContext } from 'plp/context'
import { useAnalytics } from 'plp/hooks/useAnalytics'
import type { ColumnsNumber } from 'plp/types/Options'
import { EventName } from 'plp/types/eventsObserver'
import { eventsObserver } from 'plp/utils/eventsObserver'
import { ColumnLayout } from 'product-card/types'
import { useCallback } from 'react'

import { Selector } from './Selector/Selector'

import styles from './Columns.module.scss'

interface ColumnsProps {
	isSmall: boolean
	hasServerFilters: boolean
}

export function Columns({
	isSmall,
	hasServerFilters,
}: ColumnsProps): React.ReactNode {
	const { t } = useLabels()
	const { columns, setNewColumns } = usePlpContext()
	useAnalytics({ filtered: hasServerFilters })
	const firstColumns = isSmall
		? ColumnLayout.OneColumn
		: ColumnLayout.TwoColumns
	const secondColumns = isSmall
		? ColumnLayout.TwoColumns
		: ColumnLayout.FourColumns

	const columnsChangeHandler = useCallback(
		(newColumns: ColumnsNumber) => {
			setNewColumns(newColumns)
			eventsObserver.dispatch<{ columns: number }>(EventName.CHANGE_COLUMNS, {
				columns,
			})
		},
		[setNewColumns]
	)

	return (
		<div className={styles.root}>
			{!isSmall && t('plp.view.columns.text')}
			<Selector
				columns={firstColumns}
				isCurrentTab={columns === firstColumns}
				isSmall={isSmall}
				handleClick={columnsChangeHandler}
			/>
			{!isSmall && <span role='presentation' className={styles.separator} />}
			<Selector
				columns={secondColumns}
				isCurrentTab={columns === secondColumns}
				isSmall={isSmall}
				handleClick={columnsChangeHandler}
			/>
		</div>
	)
}
